/**
 *
 * @package    YoloTheme
 * @version    1.0.0
 * @author     Administrator <admin@yolotheme.com>
 * @copyright  Copyright (c) 2016, YoloTheme
 * @license    http://opensource.org/licenses/gpl-2.0.php GPL v2 or later
 * @link       http://yolotheme.com
 */

var CELINA = CELINA || {};
jQuery(document).ready(function($) {
    "use strict";
    var $window = $(window),
        $html = $('html'),
        $body = $('body'),
        $pageContent = $('#page-content'),
        animateQueueDelay = 200,
        queueResetDelay,
        isRTL = $body.hasClass('rtl') ? true : false,
        deviceAgent = navigator.userAgent.toLowerCase(),
        isMobile = deviceAgent.match(/(iphone|ipod|android|iemobile)/),
        isMobileAlt = deviceAgent.match(/(iphone|ipod|ipad|android|iemobile)/),
        isAppleDevice = deviceAgent.match(/(iphone|ipod|ipad)/),
        isIEMobile = deviceAgent.match(/(iemobile)/);

    yoloInitGrid();
    initVideoPopups();

    function yoloInitGrid() {
        $('.yolo-grid-wrapper').each(function() {
            var $el = $(this),
                $grid = $el.find('.yolo-grid-inner');

            var $items = $grid.children('.grid-item');

            if ($grid.hasClass('has-animation')) {
                yoloInitGridAnimation($grid, $items);
            }


        });
    }

    function processItemQueue(itemQueue, queueDelay, queueTimer, queueResetDelay) {
        clearTimeout(queueResetDelay);
        queueTimer = window.setInterval(function() {
            if (itemQueue !== undefined && itemQueue.length) {
                $(itemQueue.shift()).addClass('animate');
                processItemQueue();
            } else {
                window.clearInterval(queueTimer);
            }
        }, queueDelay);
    }


    function yoloInitGridAnimation($grid, $items) {
        if (!$body.hasClass('page-has-animation') || !$grid.hasClass('has-animation')) {
            return;
        }

        var itemQueue = [],
            queueDelay = animateQueueDelay,
            queueTimer;


        $items.elementorWaypoint(function() {
            // Fix for different ver of waypoints plugin.
            var _self = this.element ? this.element : $(this);

            itemQueue.push(_self);
            processItemQueue(itemQueue, queueDelay, queueTimer);
            queueDelay += 250;

            queueResetDelay = setTimeout(function() {
                queueDelay = animateQueueDelay;
            }, animateQueueDelay);
        }, {
            offset: '90%',
            triggerOnce: true
        });
    }

    function initVideoPopups() {
        $('.yolo-popup-video').each(function() {
            handlerPopupVideo($(this));
        });
    }

    function handlerPopupVideo($popup) {
        var options = {
            selector: 'a',
            fullScreen: false,
            zoom: false,
            getCaptionFromTitleOrAlt: false,
            counter: false,
            thumbnail: false,
            controls: false,
            mousewheel: false,
            share: false,
            rotate: false,
            mode: 'lg-scale-up',
            videoMaxWidth: "2000px",
            autoplayFirstVideo: true,
            youtubePlayerParams: { modestbranding: 0, showinfo: 0, controls: 1, rel: 0, autoplay: 1 },
        };
        $popup.lightGallery(options);
    }

    CELINA.common = {
        init: function() {
            CELINA.common.owlCarousel();
            CELINA.common.tooltip();
            CELINA.common.accessoriesOwl();
            CELINA.common.subMenuPosition();

            CELINA.common.filter_Tabs();
            CELINA.common.tab_loadmore();
            CELINA.common.product_loadmore();
            CELINA.common.lightGallery();

        },

        lightGallery: function() {
            var lightGallery = $("div.lightGallery-js");
            if (lightGallery.length > 0) {
                lightGallery.lightGallery({
                    selector: '.item',
                    thumbnail: false,
                    mousewheel: false,
                    share: false,
                    rotate: false,
                    mode: 'lg-scale-up',
                });
            };
        },

        product_loadmore: function() {
            // Click loadmore from shortcode Product Tabs
            if ($('.yolo-product-loadmore').length > 0) {
                $('.yolo-product-loadmore').each(function() {
                    $(this).on('click', function(event) {
                        event.preventDefault();
                        var $this_ = $(this);
                        if (!$this_.hasClass('loaded')) {
                            var query_types, tab, orderby, number_load, start, loadtext, loadedtext, wrapid, col, product_style, loadmore;
                            query_types = $this_.attr('data-query-types');
                            tab = $this_.attr('data-tab');
                            orderby = $this_.attr('data-orderby');
                            number_load = $this_.attr('data-number-load');
                            product_style = $this_.attr('data-product-style');
                            start = $this_.attr('data-start');
                            col = $this_.attr('data-col');
                            loadmore = $this_.attr('data-use_loadmore');
                            wrapid = $(this).parents('.yolo-product-tabs-wrap').attr('id');
                            $(this).addClass('yolo-spin');
                            $.ajax({
                                url: celina_framework_ajax_url,
                                data: {
                                    action: 'yolo_product_loadmore',
                                    query_types: query_types,
                                    tab: tab,
                                    product_style: product_style,
                                    orderby: orderby,
                                    number_load: number_load,
                                    start: start,
                                    col: col,
                                    loadmore: loadmore,
                                },
                                type: 'POST',
                                success: function(newElements, data) {
                                    if ($.trim(data) != '') {
                                        var $newElems = $(newElements).css({
                                            opacity: 0
                                        });
                                        $('#' + wrapid + ' .yolo-product-tab-content .yolo-product-inner .yolo-template-tab').append($newElems);
                                        $newElems.imagesLoaded(function() {
                                            $newElems.animate({
                                                opacity: 1
                                            }, 300);
                                        });
                                        $($this_).removeClass('yolo-spin');
                                        CELINA.common.tooltip();
                                        if ((parseInt(start) + parseInt(number_load)) > $('#' + wrapid + ' .yolo-product-tab-content .yolo-product-inner .product-item-wrap').size()) {
                                            $('.yolo-product-loadmore').html('<div class="yolo-show-all jhana-btn">' + celina_framework_constant.yolo_all_products + '</div>').addClass('yolo-all-product');
                                        }

                                        $($this_).attr('data-start', parseInt(start) + parseInt(number_load));

                                    } else {
                                        $($this_).removeClass('yolo-spin');
                                    }
                                }
                            });
                        } else {
                            return false;
                        }
                    });
                });
            }
        },

        tab_loadmore: function() {
            if ($('.yolo-product-tabs-wrap').length > 0) {
                $('.yolo-product-tabs-wrap').each(function() {
                    var $wapp_id = $(this).attr('id');
                    // Click load tab
                    $(this).find('.yolo-product-filters .yolo-product-filter-tabs li a.yolo-tab').on('click', function(e) {
                        var $this = $(this);
                        $('#' + $wapp_id + ' .yolo-product-tab-content').addClass('yolo-loading');
                        var wrap_id = $(this).attr('data-wrap-id'),
                            query_types = $(this).attr('data-query_types'),
                            tab = $(this).attr('data-tab'),
                            orderby = $(this).attr('data-orderby'),
                            number_query = $(this).attr('data-number_query'),
                            number_load = $(this).attr('data-number_load'),
                            number_display = $(this).attr('data-number_display'),
                            col = $(this).attr('data-col'),
                            loadmore = $(this).attr('data-use_loadmore');
                        $.ajax({
                            url: celina_framework_ajax_url,
                            data: {
                                action: 'yolo_tab_load_products',
                                wrap_id: wrap_id,
                                query_types: query_types,
                                tab: tab,
                                orderby: orderby,
                                number_query: number_query,
                                number_load: number_load,
                                number_display: number_display,
                                col: col,
                                loadmore: loadmore,
                            },
                            type: 'POST',
                            success: function(data) {
                                if (data != '') {
                                    setTimeout(function() {
                                        $('#' + $wapp_id + ' .yolo-product-tab-content').removeClass('yolo-loading');
                                        $('#' + $wapp_id + ' .yolo-product-tab-content .yolo-product-inner').html(data).hide();
                                        $('#' + $wapp_id + ' .yolo-product-tab-content .yolo-product-inner').fadeIn(1000);
                                        CELINA.common.product_loadmore();
                                    }, 500);

                                } else {

                                }
                            }
                        });
                    });
                });
            }
        },

        filter_Tabs: function() {
            if ($('.yolo-product-tabs-wrap').length > 0) {
                $('.yolo-product-tabs-wrap').each(function() {
                    var $wapp_id = $(this).attr('id');
                    $('#' + $wapp_id + ' .yolo-product-filter-tabs').find("li").first().addClass("active");
                    $('#' + $wapp_id + ' .yolo-product-filter-tabs > li').on('click', function(e) {
                        if (!$(this).hasClass('active')) {
                            $('#' + $wapp_id + ' .yolo-product-filter-tabs li').removeClass('active');
                            $(this).addClass('active');
                            return false;
                        }
                    });
                });
            }
        },

        isDesktop: function() {
            var responsive_breakpoint = 991;
            return window.matchMedia('(min-width: ' + (responsive_breakpoint + 1) + 'px)').matches;
        },
        isIE: function() {
            var ua = window.navigator.userAgent;
            var msie = ua.indexOf("MSIE ");

            if (msie || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
                return true;
            }
            return false;
        },

        owlCarousel: function() {
            $('div.owl-carousel[data-plugin-options]').each(function() {
                var slider = $(this);
                var rtl = slider.data('rtl'),
                    loop = slider.data('loop');
                var columns = slider.data("plugin-options"),
                    config = {};
                var defaults = {
                    // Most important owl features
                    items: 4,
                    rtl: rtl ? rtl : false,
                    loop: loop ? loop : false,
                    autoplay: false,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: true,
                    autoHeight: true,
                    margin: 0,
                    nav: true,
                    dots: true,
                    navText: ["<i class='fal fa-caret-left'></i>", "<i class='fal fa-caret-right'></i>"],
                    slideBy: 1,
                };
                if (columns >= 3) {
                    config = {
                        item: columns,
                        margin: 0,
                        responsive: {
                            0: {
                                items: 1
                            },
                            680: {
                                items: 2
                            },

                            991: {
                                items: 3
                            },
                            1200: {
                                items: columns ? parseInt(columns) : 3
                            },
                            1300: {
                                items: columns ? parseInt(columns) : 3
                            }
                        }
                    }
                }
                if (columns < 3) {
                    var config = {
                        item: columns,
                        margin: 0,
                        responsive: {
                            0: {
                                items: 1
                            },
                            991: {
                                items: columns ? parseInt(columns) : 1
                            }
                        }
                    }
                }
                var configs = $.extend(defaults, config);
                // Initialize Slider
                slider.owlCarousel(configs);
            });
        },
        accessoriesOwl: function() {
            $('.accessories .yolo-slider').each(function() {
                var columns = $(this).attr('data-col');
                $(this).owlCarousel({
                    items: columns,
                    margin: 0,
                    rtl: isRTL,
                    responsive: {
                        0: {
                            items: 1
                        },
                        500: {
                            items: 1
                        },
                        991: {
                            items: 2
                        },
                        1200: {
                            items: columns
                        },
                        1300: {
                            items: columns
                        }
                    },
                });
            });
        },

        tooltip: function() {
            if ($().tooltip && !isMobileAlt) {
                $('.button-has-tooltip').each(function() {
                    // @TODO: need change tooltip when added to cart,...
                    $(this).find('.yith-wcwl-add-button.show', '.product-actions').tooltip({
                        title: celina_framework_constant.product_wishList
                    });
                    $(this).find('.yith-wcwl-wishlistexistsbrowse.show,.yith-wcwl-wishlistaddedbrowse.show', '.product-actions').tooltip({
                        title: celina_framework_constant.product_wishList_added
                    });

                    $(this).find('.compare,.add_to_compare').tooltip({
                        title: celina_framework_constant.product_compare
                    });
                    $(this).find('[data-toggle="tooltip"]').tooltip();

                    $(this).find('.product-quick-view', '.product-actions').tooltip({
                        title: celina_framework_constant.product_quickview
                    });
                });
            }
        },
        subMenuPosition: function() {
            $("ul.yolo-main-menu li li.menu-item-has-children").mouseenter(function() {
                if ($(this).children('ul').length == 1) {
                    var parent = $(this);
                    var child_menu = $(this).children('ul');
                    if ($(parent).offset().left + $(parent).width() + $(child_menu).width() > $(window).width()) {
                        if (isRTL) {
                            $(child_menu).css('right', '-' + $(parent).width() + 'px');
                        } else {
                            $(child_menu).css('left', '-' + $(parent).width() + 'px');
                        }

                    } else {
                        if(isRTL) {
                            $(child_menu).css('right', $(parent).width() + 'px');
                        } else {
                            $(child_menu).css('left', $(parent).width() + 'px');
                        }

                    }
                }
            });
        }
    };

    CELINA.page = {
        init: function() {
            CELINA.page.backToTop();
            CELINA.page.pageIn();
        },

        backToTop: function() {
            var $backToTop = $('.back-to-top');
            if ($backToTop.length > 0) {
                $backToTop.click(function(event) {
                    event.preventDefault();
                    $('html,body').animate({ scrollTop: '0px' }, 800);
                });
                $window.on('scroll', function(event) {
                    var scrollPosition = $window.scrollTop();
                    var windowHeight = $window.height() / 2;
                    if (scrollPosition > windowHeight) {
                        $backToTop.addClass('in');
                    } else {
                        $backToTop.removeClass('in');
                    }
                });
            }
        },
        pageIn: function() {
            setTimeout(function() {
                $('#yolo-site-preload').fadeOut(300);
            }, 300);
        },
    };

    CELINA.blog = {
        init: function() {
            CELINA.blog.loadMore();
            CELINA.blog.masonry();
        },

        loadMore: function() {
            $('.blog-load-more').on('click', function(event) {
                event.preventDefault();
                var $this = $(this).button('loading');
                var link = $(this).attr('data-href');
                var loading = $(this).attr('data-loading-text');
                var load_more = $(this).attr('data-load-text');
                var contentWrapper = '.blog-inner';
                var element = 'article';

                $('.blog-load-more').text('').append(loading);
                $.get(link, function(data) {
                    var next_href = $('.blog-load-more', data).attr('data-href');
                    var $newElems = $(element, data).css({
                        opacity: 0
                    });
                    $(contentWrapper).append($newElems);
                    yoloInitGrid();
                    $('.blog-load-more').text(load_more);
                    $('.blog-load-more').blur();
                    if (typeof(next_href) == 'undefined') {
                        $this.parent().remove();
                    } else {
                        $this.button('reset');
                        $this.attr('data-href', next_href);
                    }

                });
            });
        },

        masonry: function() {
            var $blog_masonry = $('.blog-masonry');
            if ($blog_masonry.length > 0) {
                $blog_masonry.imagesLoaded(function() {
                    $blog_masonry.isotope({
                        itemSelector: 'article',
                        layoutMode: "masonry",
                        isOriginLeft: !isRTL
                    });

                    setTimeout(function() {
                        $blog_masonry.isotope('layout');
                    }, 500);
                });
            }
        }
    };

    CELINA.woocommerce = {
        init: function() {
            CELINA.woocommerce.setCartScrollBar();
            CELINA.woocommerce.removeCart();
            CELINA.woocommerce.addCartQuantity();
            CELINA.woocommerce.productSingleTabScroll();
            CELINA.woocommerce.addToCart();
            CELINA.woocommerce.compare();
            CELINA.woocommerce.updateShippingMethod();
            CELINA.woocommerce.addToWishlist();
            CELINA.woocommerce.spSticky();
        },

        setCartScrollBar: function() {
            if ($('.mini-cart-hover').length > 0) {
                $('.mini-cart-hover .woocommerce-mini-cart').mCustomScrollbar({
                    theme: "rounded-dark",
                    scrollbarPosition: "inside"
                });
            }
        },
        removeCart: function() {
            if ($('#mini-cart-canvas').length > 0) {
                $('#mini-cart-canvas').on('click', '.mini-cart-remove', function() {
                    $(document).ajaxStop(function() {
                        CELINA.header.canvas_cart();
                    })
                });
            } else {
                $(document).on('click', '.mini-cart-remove', function() {
                    setTimeout(function() {
                        CELINA.woocommerce.setCartScrollBar();
                    }, 2000);
                });
            }
        },
        productSingleTabScroll: function() {
            if ($('.menu-one-page').length > 0) {
                $('.menu-one-page').onePageNav({
                    currentClass: 'active',
                    changeHash: false,
                    scrollSpeed: 750,
                    scrollThreshold: 0.5,
                });
            }
        },
        addCartQuantity: function() {
            $(document).off('click', '.quantity .btn-number').on('click', '.quantity .btn-number', function(event) {
                event.preventDefault();
                var type = $(this).data('type'),
                    input = $('input', $(this).parent()),
                    current_value = parseFloat(input.val()),
                    max = parseFloat(input.attr('max')),
                    min = parseFloat(input.attr('min')),
                    step = parseFloat(input.attr('step')),
                    stepLength = 0;
                if (input.attr('step').indexOf('.') > 0) {
                    stepLength = input.attr('step').split('.')[1].length;
                }

                if (isNaN(max)) {
                    max = 100;
                }
                if (isNaN(min)) {
                    min = 0;
                }
                if (isNaN(step)) {
                    step = 1;
                    stepLength = 0;
                }

                if (!isNaN(current_value)) {
                    if (type == 'minus') {
                        if (current_value > min) {
                            current_value = (current_value - step).toFixed(stepLength);
                            input.val(current_value).change();
                        }

                        if (parseFloat(input.val()) <= min) {
                            input.val(min).change();
                            $(this).attr('disabled', true);
                        }
                    }

                    if (type == 'plus') {
                        if (current_value < max) {
                            current_value = (current_value + step).toFixed(stepLength);
                            input.val(current_value).change();
                        }
                        if (parseFloat(input.val()) >= max) {
                            input.val(max).change();
                            $(this).attr('disabled', true);
                        }
                    }
                } else {
                    input.val(min);
                }
            });


            $('input', '.quantity').focusin(function() {
                $(this).data('oldValue', $(this).val());
            });

            $('input', '.quantity').on('change', function() {
                var input = $(this),
                    max = parseFloat(input.attr('max')),
                    min = parseFloat(input.attr('min')),
                    current_value = parseFloat(input.val()),
                    step = parseFloat(input.attr('step'));

                if (isNaN(max)) {
                    max = 100;
                }
                if (isNaN(min)) {
                    min = 0;
                }

                if (isNaN(step)) {
                    step = 1;
                }
                var btn_add_to_cart = $('.add_to_cart_button', $(this).parent().parent().parent());
                if (current_value >= min) {
                    $(".btn-number[data-type='minus']", $(this).parent()).removeAttr('disabled');
                    if (typeof(btn_add_to_cart) != 'undefined') {
                        btn_add_to_cart.attr('data-quantity', current_value);
                    }

                } else {
                    alert('Sorry, the minimum value was reached');
                    $(this).val($(this).data('oldValue'));

                    if (typeof(btn_add_to_cart) != 'undefined') {
                        btn_add_to_cart.attr('data-quantity', $(this).data('oldValue'));
                    }
                }

                if (current_value <= max) {
                    $(".btn-number[data-type='plus']", $(this).parent()).removeAttr('disabled');
                    if (typeof(btn_add_to_cart) != 'undefined') {
                        btn_add_to_cart.attr('data-quantity', current_value);
                    }
                } else {
                    alert('Sorry, the maximum value was reached');
                    $(this).val($(this).data('oldValue'));
                    if (typeof(btn_add_to_cart) != 'undefined') {
                        btn_add_to_cart.attr('data-quantity', $(this).data('oldValue'));
                    }
                }

            });
        },
        addToCart: function() {
            $(document).on('click', '.add_to_cart_button', function() {
                var button = $(this);
                if (!button.hasClass('single_add_to_cart_button') && button.is('.product_type_simple')) {

                    button.addClass("added-spinner");
                    button.find('i').attr('class', 'fal fa-spinner fa-spin');
                }
            });
            $(document).bind("added_to_cart", function(event, fragments, cart_hash, $thisbutton) {
                CELINA.woocommerce.setCartScrollBar();
                var is_single_product = $thisbutton.hasClass('single_add_to_cart_button');
                if (is_single_product) return;
                var button = $thisbutton,
                    buttonWrap = button.parent(),
                    buttonViewCart = buttonWrap.find('.added_to_cart'),
                    addedTitle = buttonViewCart.text(),
                    productWrap = buttonWrap.parent().parent().parent().parent();
                button.remove();
                setTimeout(function() {
                    $('.button-has-tooltip .added_to_cart').each(function() {
                        buttonWrap.tooltip('hide').attr('title', addedTitle).tooltip('fixTitle');
                    });
                }, 500);

                setTimeout(function() {
                    productWrap.removeClass('active');
                }, 700);

            });
        },
        compare: function() {
            $('.add_to_compare').on('click', function(event) {
                event.preventDefault();
                var button = $(this),
                    buttonWrap = button.parent();
                button.find('i').attr('class', 'fal fa-spinner fa-spin');
                var productWrap = buttonWrap.parent().parent().parent().parent();
                if (typeof(productWrap) == 'undefined') {
                    return;
                }
                productWrap.addClass('active');
            });
        },
        updateShippingMethod: function() {
            $body.bind('updated_shipping_method', function() {
                $('select.country_to_state, input.country_to_state').change();
            });
        },
        addToWishlist: function() {
            $('.product-item-wrap').on('click', '.add_to_wishlist', function() {
                var button = $(this),
                    buttonWrap = button.parent().parent();
                if (!buttonWrap.parent().hasClass('single-product-function')) {
                    button.addClass("added-spinner");
                    button.append('<i class = "fal fa-spinner fa-spin"></i>');
                }

            });

            $body.bind("added_to_wishlist", function(event, fragments, cart_hash, $thisbutton) {
                var button = $('.added-spinner.add_to_wishlist'),
                    buttonWrap = button.parent().parent();
                if (!buttonWrap.parent().hasClass('single-product-function')) {
                    setTimeout(function() {
                        button.find('i').removeClass('fal fa-spinner fa-spin');
                        button.removeClass('added-spinner');
                    }, 700);
                }
                // Add to update wishlist
                CELINA.woocommerce.updateWishlist();
            });
            // Add to update wishlist on wishlist page
            $('#yith-wcwl-form table tbody tr td a.remove, #yith-wcwl-form table tbody tr td a.add_to_cart_button').on('click', function() {
                var old_num_product = $('#yith-wcwl-form table tbody tr[id^="yith-wcwl-row"]').length;
                var count = 1;
                var time_interval = setInterval(function() {
                    count++;
                    var new_num_product = $('#yith-wcwl-form table tbody tr[id^="yith-wcwl-row"]').length;
                    if (old_num_product != new_num_product || count == 20) {
                        clearInterval(time_interval);
                        CELINA.woocommerce.updateWishlist();
                    }
                }, 500);
            });
        },
        updateWishlist: function() {
            if (typeof celina_framework_ajax_url[0] == 'undefined') {
                return;
            }

            var wishlist_wrapper = jQuery('.my-wishlist-wrapper');
            if (wishlist_wrapper.length == 0) {
                return;
            }

            wishlist_wrapper.addClass('loading');

            jQuery.ajax({
                type: 'POST',
                url: celina_framework_ajax_url[0],
                data: { action: 'update_woocommerce_wishlist' },
                success: function(response) {
                    var first_icon = wishlist_wrapper.children('i.fa:first');
                    wishlist_wrapper.html(response);
                    if (first_icon.length > 0) {
                        wishlist_wrapper.prepend(first_icon);
                    }
                    wishlist_wrapper.removeClass('loading');
                }
            });
            // Add wishlist tooltip for shop default and yl_product_layout plugin
            setTimeout(function() {
                $('.button-has-tooltip').each(function() {
                    $(this).find('.yith-wcwl-wishlistexistsbrowse.show,.yith-wcwl-wishlistaddedbrowse.show').tooltip({
                        title: celina_framework_constant.product_wishList_added
                    });
                });
            }, 500);
        },
        spSticky: function() {
            if ($.fn.stick_in_parent && $(window).width() > 767) {
                $(".sp-sticky").stick_in_parent({
                    offset_top: 90
                });
            }
        }

    };

    CELINA.search = {
        up: function($wrapper) {
            var $item = $('li.selected', $wrapper);
            if ($('li', $wrapper).length < 2) return;
            var $prev = $item.prev();
            $item.removeClass('selected');
            if ($prev.length) {
                $prev.addClass('selected');
            } else {
                $('li:last', $wrapper).addClass('selected');
                $prev = $('li:last', $wrapper);
            }
            var $ajaxSearchResult = $(' > ul', $wrapper);

            if ($prev.position().top < $ajaxSearchResult.scrollTop()) {
                $ajaxSearchResult.scrollTop($prev.position().top);
            } else if ($prev.position().top + $prev.outerHeight() > $ajaxSearchResult.scrollTop() + $ajaxSearchResult.height()) {
                $ajaxSearchResult.scrollTop($prev.position().top - $ajaxSearchResult.height() + $prev.outerHeight());
            }
        },
        down: function($wrapper) {
            var $item = $('li.selected', $wrapper);
            if ($('li', $wrapper).length < 2) return;
            var $next = $item.next();
            $item.removeClass('selected');
            if ($next.length) {
                $next.addClass('selected');
            } else {
                $('li:first', $wrapper).addClass('selected');
                $next = $('li:first', $wrapper);
            }
            var $ajaxSearchResult = $('> ul', $wrapper);

            if ($next.position().top < $ajaxSearchResult.scrollTop()) {
                $ajaxSearchResult.scrollTop($next.position().top);
            } else if ($next.position().top + $next.outerHeight() > $ajaxSearchResult.scrollTop() + $ajaxSearchResult.height()) {
                $ajaxSearchResult.scrollTop($next.position().top - $ajaxSearchResult.height() + $next.outerHeight());
            }
        }
    };

    CELINA.header = {
        timeOutSearch: null,
        init: function() {
            CELINA.header.stickyHeader();
            CELINA.header.menuMobile();
            CELINA.header.events();
            CELINA.header.search();
            CELINA.header.searchAjaxForm();
            CELINA.header.searchCategory();
            CELINA.header.canvasMenu();
        },
        events: function() {
            // Anchors Position
            $("a[data-hash]").on("click", function(e) {
                e.preventDefault();
                CELINA.page.anchorsPosition(this);
                return false;
            });
        },
        windowResized: function() {
            CELINA.header.stickyHeader();

            if (CELINA.common.isDesktop()) {
                $('.toggle-icon-wrapper[data-drop]').removeClass('in');
            }
            var $adminBar = $('#wpadminbar');

            if ($adminBar.length > 0) {
                $body.attr('data-offset', $adminBar.outerHeight() + 1);
            }
            if ($adminBar.length > 0) {
                $body.attr('data-offset', $adminBar.outerHeight() + 1);
            }
            CELINA.header.headerMobilePosition();
        },
        windowLoad: function() {
            CELINA.header.headerMobilePosition();
            CELINA.header.fixStickyLogoSize();
        },
        fixStickyLogoSize: function() {
            // if IE
            if (CELINA.common.isIE()) {
                var $logo = $("header .logo-sticky img");
                if ($logo.length == 0) {
                    return;
                }
                var logo_url = $logo.attr('src');
                if (logo_url.length - logo_url.lastIndexOf('.svg') != 4) {
                    return;
                }
                $.get(logo_url, function(svgxml) {
                    /* now with access to the source of the SVG, lookup the values you want... */
                    var attrs = svgxml.documentElement.attributes;

                    var pic_real_width = attrs.width.value; // Note: $(this).width() will not
                    var pic_real_height = attrs.height.value; // work for in memory images.

                    if (typeof(pic_real_width) == "string") {
                        pic_real_width = pic_real_width.replace('px', '');
                        pic_real_width = parseInt(pic_real_width, 10);
                    }
                    if (typeof(pic_real_height) == "string") {
                        pic_real_height = pic_real_height.replace('px', '');
                        pic_real_height = parseInt(pic_real_height, 10);
                    }

                    if (pic_real_height > 0) {
                        $logo.css('width', (pic_real_width * 30 / pic_real_height) + 'px');
                    }
                }, "xml");

            }
        },
        headerMobilePosition: function() {
            var top = 0;
            if (($('#wpadminbar').length > 0)) {
                top = $('#wpadminbar').outerHeight();
            }
            if (top > 0 && ($('#wpadminbar').css('position') == 'fixed')) {
                $('.yolo-mobile-header-nav.menu-drop-fly').css('top', top + 'px');
                $('#wpadminbar').css('top', '');
            } else if (top > 0 && ($('#wpadminbar').css('position') == 'absolute')) {
                $('#wpadminbar').css('top', -top + 'px');
                $('.yolo-mobile-header-nav.menu-drop-fly').css('top', '');
            } else {
                $('.yolo-mobile-header-nav.menu-drop-fly').css('top', '');
                $('#wpadminbar').css('top', '');
            }
            if ($('.header-2').length || $('.header-3').length) {
                var header_height = $('.yolo-main-header').outerHeight();
                $('.yolo-main-header').css("height", header_height);
            }
        },
        stickyHeader: function() {
            if ($('.header-sticky').length > 0) {
                var topSpacing = 0,
                    $adminBar = $('#wpadminbar');

                if (($adminBar.length > 0) && ($adminBar.css('position') == 'fixed')) {
                    topSpacing = $adminBar.outerHeight();
                }

                $('.header-sticky, .header-mobile-sticky').unstickHeaderYolo();
                var topSticky = topSpacing,
                    sticky_effect = $('.header-sticky').attr('data-effect');
                if (CELINA.common.isDesktop()) {
                    topSpacing = -$(window).height() / 3;
                    $('.header-sticky').stickyHeaderYolo({
                        topSpacing: topSpacing,
                        topSticky: topSticky,
                        animated: sticky_effect
                    });
                } else {
                    $('.header-mobile-sticky').stickyHeaderYolo({ topSpacing: topSpacing, topSticky: topSticky });
                }
            }
        },
        menuOnePage: function() {
            if ($('.menu-one-page').length > 0) {
                $('.menu-one-page').onePageNav({
                    currentClass: 'active',
                    changeHash: false,
                    scrollSpeed: 750,
                    scrollThreshold: 0.5,
                });
            }
        },
        anchorsPosition: function(obj, time) {
            var target = $(obj).attr("href");
            if ($(target).length > 0) {
                var _scrollTop = $(target).offset().top,
                    $adminBar = $('#wpadminbar');
                if ($adminBar.length > 0) {
                    _scrollTop -= $adminBar.outerHeight();
                }
                $("html,body").animate({ scrollTop: _scrollTop }, time, 'swing', function() {

                });
            }
        },
        menuMobile: function() {
            $('.toggle-mobile-menu[data-ref]').click(function(event) {
                event.preventDefault();
                var $this = $(this);
                var data_drop = $this.data('ref');
                $this.toggleClass('in');
                switch ($this.data('drop-type')) {
                    case 'dropdown':
                        $('#' + data_drop).slideToggle();
                        break;
                    case 'fly':
                        $('body').toggleClass('menu-mobile-in');
                        $('#' + data_drop).toggleClass('in');
                        break;
                }

            });

            $('.toggle-icon-wrapper[data-ref]:not(.toggle-mobile-menu)').click(function(event) {
                event.preventDefault();
                var $this = $(this);
                var data_ref = $this.data('ref');
                $this.toggleClass('in');
                $('#' + data_ref).toggleClass('in');
            });

            $('.yolo-mobile-menu-overlay').click(function() {
                $body.removeClass('menu-mobile-in');
                $('#yolo-nav-mobile-menu').removeClass('in');
                $('.toggle-icon-wrapper[data-ref]').removeClass('in');
            });
        },
        canvas_cart: function() {
            var h_cart, h = $(window).height();
            h_cart = h - 330;
            $('.woocommerce-mini-cart').css('max-height', h_cart + 'px');
        },
        canvas_wishlist: function() {
            var h_wishlist, h = $(window).height();
            if ($('#wishlists-canvas').length > 0) {
                h_wishlist = h - 170;
                $('.wishlists-content').css('max-height', h_wishlist + 'px');
            }
        },
        canvasMenu: function() {
            $(document).on('click', function(event) {
                if (($(event.target).closest('nav.yolo-canvas-menu-wrapper').length == 0) &&
                    ($(event.target).closest('.canvas-menu-toggle')).length == 0) {
                    $('nav.yolo-canvas-menu-wrapper').removeClass('in');
                }
            });

            $('body').on('click', '.canvas-menu-toggle', function(event) {
                event.preventDefault();
                var data = $(this).data('id');

                if ($('nav.yolo-canvas-menu-wrapper').hasClass('in') && !$('nav.yolo-canvas-menu-wrapper#' + data).hasClass('in')) {
                    $('nav.yolo-canvas-menu-wrapper').removeClass('in')
                }
                $('nav.yolo-canvas-menu-wrapper#' + data).toggleClass('in');
                if ($('#wishlists-canvas').length) {
                    CELINA.header.canvas_wishlist();
                }
                if ($('#mini-cart-canvas').length) {
                    CELINA.header.canvas_cart();
                }

            });

            $('.yolo-canvas-menu-close').on('click', function(event) {
                event.preventDefault();
                $('nav.yolo-canvas-menu-wrapper').removeClass('in');
            });

            // Mini Cart Canvas
            if ($('#mini-cart-canvas').length > 0) {

                $(document).on('click', '.add_to_cart_button', function(event) {
                    setTimeout(function() {
                        $('#mini-cart-canvas').addClass('in');
                        CELINA.header.canvas_cart();
                    }, 2000);
                });
            }

            // Wishlist Canvas
            if ($('#wishlists-canvas').length) {

                $('#wishlists-canvas').on('click', '.remove_from_wishlist', function(event) {

                    event.preventDefault();
                    var t = $(this),
                        pr = t.parents('tr'),
                        btn = t.parents('#wishlists-canvas').find('.wl-button');
                    $.ajax({
                        url: celina_framework_app.ajax_url,
                        type: 'GET',
                        dataType: 'html',
                        data: {
                            action: 'remove_from_wishlist'
                        },
                        beforeSend: function() {
                            t.parents('tr').append('<div class="spinner-bg"><span class="spinner is-active" style="background-image: url(' + celina_framework_app.image_load + ')"></span></div>');
                        },
                        success: function() {

                            if (pr.length) {
                                setTimeout(function() {
                                    pr.remove();
                                }, 300);
                            }
                            t.parents('tr').find('.spinner-bg').remove();

                            var count = t.parents('tbody').find('tr').length;
                            if (count == 1) {
                                btn.addClass('hidden');
                                $('.yolo-wishlist span').html('0');
                            } else {
                                $('.yolo-wishlist span').html(count - 1);
                            }
                        }
                    });
                });

                $('main').on('click', '.remove_from_wishlist', function(event) {
                    event.preventDefault();
                    var t = $(this),
                        hr = t.attr('href'),
                        hrd = jQuery('#wishlists-canvas tbody > tr > .product-remove a').attr('href'),
                        hrd_hr = hrd.split('?')[0],
                        pr = jQuery('#wishlists-canvas a[href="' + hr + '"]').parents('tr');

                    if (hr.indexOf('admin-ajax.php') != -1 && hrd_hr != '') {
                        hr = hrd_hr + '?' + hr.split('?')[1]
                        pr = jQuery('#wishlists-canvas a[href="' + hr + '"]').parents('tr');
                    }

                    if (pr.length) {
                        setTimeout(function() {
                            pr.remove();
                            if (t.parents('tbody').find('tr').length == 1) {
                                jQuery('#wishlists-canvas .wl-button').addClass('hidden');
                            }
                        }, 2000)
                    }

                });

                $('body').on('click', '.add_to_wishlist', function(event) {
                    event.preventDefault();
                    var el = $(this),
                        product_id = el.data('product-id'),
                        el_wrap = $('.add-to-wishlist-' + product_id),
                        data = {
                            add_to_wishlist: product_id,
                            product_type: el.data('product-type'),
                            action: yith_wcwl_l10n.actions.add_to_wishlist_action
                        };

                    if (yith_wcwl_l10n.multi_wishlist && yith_wcwl_l10n.is_user_logged_in) {
                        var wishlist_popup_container = el.parents('.yith-wcwl-popup-footer').prev('.yith-wcwl-popup-content'),
                            wishlist_popup_select = wishlist_popup_container.find('.wishlist-select'),
                            wishlist_popup_name = wishlist_popup_container.find('.wishlist-name'),
                            wishlist_popup_visibility = wishlist_popup_container.find('.wishlist-visibility');

                        data.wishlist_id = wishlist_popup_select.val();
                        data.wishlist_name = wishlist_popup_name.val();
                        data.wishlist_visibility = wishlist_popup_visibility.val();
                    }

                    $.ajax({
                        type: 'POST',
                        url: yith_wcwl_l10n.ajax_url,
                        data: data,
                        dataType: 'json',
                        beforeSend: function() {
                            el.siblings('.ajax-loading').css('visibility', 'visible');
                        },
                        complete: function() {
                            el.siblings('.ajax-loading').css('visibility', 'hidden');
                        },
                        success: function(response) {

                            var form = $('#wishlists-canvas .wishlists-content > form');

                            reload_wishlist_and_adding_elem(el, form);

                        }
                    });

                });

                function reload_wishlist_and_adding_elem(el, form) {
                    var product_id = el.data('product-id'),
                        table = $(document).find('.cart.wishlist_table'),
                        pagination = table.data('pagination'),
                        per_page = table.data('per-page'),
                        wishlist_id = table.data('id'),
                        wishlist_token = table.data('token'),
                        data = {
                            action: yith_wcwl_l10n.actions.reload_wishlist_and_adding_elem_action,
                            pagination: pagination,
                            per_page: per_page,
                            wishlist_id: wishlist_id,
                            wishlist_token: wishlist_token,
                            add_to_wishlist: product_id,
                            product_type: el.data('product-type')
                        };
                    $.ajax({
                        type: 'POST',
                        url: yith_wcwl_l10n.ajax_url,
                        data: data,
                        dataType: 'html',
                        success: function(res) {
                            var obj = $(res),
                                new_form = obj.find('#yith-wcwl-form'); // get new form
                            form.replaceWith(new_form);
                            $('#wishlists-canvas .wl-button').removeClass('hidden');
                        }
                    });
                }
            }
        },
        search: function() {
            var $search_popup = $('#yolo_search_popup_wrapper');
            if (($search_popup.length > 0) && ($('header .icon-search-menu').data('search-type') == 'standard')) {
                var dlg_search = new DialogFx($search_popup[0]);
                $('header .icon-search-menu').click(dlg_search.toggle.bind(dlg_search));

            }

            $('header .icon-search-menu').click(function(event) {
                event.preventDefault();
                if ($(this).data('search-type') == 'ajax') {
                    CELINA.header.searchPopupOpen();
                } else {
                    $('#yolo_search_popup_wrapper input[type="text"]').focus();
                }
            });

            $('.yolo-dismiss-modal, .modal-backdrop', '#yolo-modal-search').click(function() {
                CELINA.header.searchPopupClose();
            });
            $('.yolo-search-wrapper button > i.ajax-search-icon').click(function() {
                s_search();
            });

            // Search Ajax
            $('#search-ajax', '#yolo-modal-search').on('keyup', function(event) {
                if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
                    return;
                }

                var keys = ["Control", "Alt", "Shift"];
                if (keys.indexOf(event.key) != -1) return;
                switch (event.which) {
                    case 27: // ESC
                        CELINA.header.searchPopupClose();
                        break;
                    case 38: // UP
                        s_up();
                        break;
                    case 40: // DOWN
                        s_down();
                        break;
                    case 13: //ENTER
                        var $item = $('li.selected a', '#yolo-modal-search');
                        if ($item.length == 0) {
                            event.preventDefault();
                            return false;
                        }
                        s_enter();
                        break;
                    default:
                        clearTimeout(CELINA.header.timeOutSearch);
                        CELINA.header.timeOutSearch = setTimeout(s_search, 500);
                        break;
                }
            });

            function s_up() {
                var $item = $('li.selected', '#yolo-modal-search');
                if ($('li', '#yolo-modal-search').length < 2) return;
                var $prev = $item.prev();
                $item.removeClass('selected');
                if ($prev.length) {
                    $prev.addClass('selected');
                } else {
                    $('li:last', '#yolo-modal-search').addClass('selected');
                    $prev = $('li:last', '#yolo-modal-search');
                }
                if ($prev.position().top < $('#yolo-modal-search .ajax-search-result').scrollTop()) {
                    $('#yolo-modal-search .ajax-search-result').scrollTop($prev.position().top);
                } else if ($prev.position().top + $prev.outerHeight() > $('#yolo-modal-search .ajax-search-result').scrollTop() + $('#yolo-modal-search .ajax-search-result').height()) {
                    $('#yolo-modal-search .ajax-search-result').scrollTop($prev.position().top - $('#yolo-modal-search .ajax-search-result').height() + $prev.outerHeight());
                }
            }

            function s_down() {
                var $item = $('li.selected', '#yolo-modal-search');
                if ($('li', '#yolo-modal-search').length < 2) return;
                var $next = $item.next();
                $item.removeClass('selected');
                if ($next.length) {
                    $next.addClass('selected');
                } else {
                    $('li:first', '#yolo-modal-search').addClass('selected');
                    $next = $('li:first', '#yolo-modal-search');
                }
                if ($next.position().top < $('#yolo-modal-search .ajax-search-result').scrollTop()) {
                    $('#yolo-modal-search .ajax-search-result').scrollTop($next.position().top);
                } else if ($next.position().top + $next.outerHeight() > $('#yolo-modal-search .ajax-search-result').scrollTop() + $('#yolo-modal-search .ajax-search-result').height()) {
                    $('#yolo-modal-search .ajax-search-result').scrollTop($next.position().top - $('#yolo-modal-search .ajax-search-result').height() + $next.outerHeight());
                }
            }

            function s_enter() {
                var $item = $('li.selected a', '#yolo-modal-search');
                if ($item.length > 0) {
                    window.location = $item.attr('href');
                }
            }

            function s_search() {
                var keyword = $('input[type="search"]', '#yolo-modal-search').val();
                if (keyword.length < 3) {
                    $('.ajax-search-result', '#yolo-modal-search').html('');
                    return;
                }
                $('.ajax-search-icon', '#yolo-modal-search').addClass('fa-spinner fa-spin');
                $('.ajax-search-icon', '#yolo-modal-search').removeClass('fa-search');
                $.ajax({
                    type: 'POST',
                    data: 'action=result_search&keyword=' + keyword,
                    url: celina_framework_ajax_url[0],
                    success: function(data) {
                        $('.ajax-search-icon', '#yolo-modal-search').removeClass('fa-spinner fa-spin');
                        $('.ajax-search-icon', '#yolo-modal-search').addClass('fa-search');
                        var html = '';
                        var html_view_more = '';
                        if (data) {
                            var items = $.parseJSON(data);
                            if (items.length) {
                                html += '<ul>';
                                if (items[0]['id'] == -1) {
                                    html += '<li>' + items[0]['title'] + '</li>';
                                } else {
                                    $.each(items, function(index) {
                                        if (this['id'] == -2) {
                                            html_view_more = '<div class="search-view-more">' + this['title'] + '</div>';
                                        } else {
                                            if (index == 0) {
                                                html += '<li class="selected">';
                                            } else {
                                                html += '<li>';
                                            }
                                            if (this['title'] == null || this['title'] == '') {
                                                html += '<a href="' + this['guid'] + '">' + this['date'] + '</a>';
                                            } else {
                                                html += '<a href="' + this['guid'] + '">' + this['title'] + '</a>';
                                                html += '<span>' + this['date'] + ' </span>';
                                            }
                                            html += '</li>';
                                        }
                                    });
                                }


                                html += '</ul>';
                            } else {
                                html = '';
                            }
                        }
                        $('.ajax-search-result', '#yolo-modal-search').html(html + html_view_more);
                        $('#yolo-modal-search .ajax-search-result').scrollTop(0);
                    },
                    error: function(data) {
                        $('.ajax-search-icon', '#yolo-modal-search').removeClass('fa-spinner fa-spin');
                        $('.ajax-search-icon', '#yolo-modal-search').addClass('fa-search');
                    }
                });
            }
        },
        searchPopupOpen: function() {
            if (!$('#yolo-modal-search').hasClass('in')) {
                $('body').addClass('overflow-hidden');
                $('#yolo-modal-search').show();
                setTimeout(function() {
                    $('#yolo-modal-search').addClass('in');
                }, 300);

                if ($('#search-ajax', '#yolo-modal-search').length > 0) {
                    $('#search-ajax', '#yolo-modal-search').focus();
                    $('#search-ajax', '#yolo-modal-search').val('');
                } else {
                    $('#search-standard', '#yolo-modal-search').focus();
                    $('#search-standard', '#yolo-modal-search').val('');
                }

                $('.ajax-search-result', '#yolo-modal-search').html('');
            }
        },
        searchPopupClose: function() {
            if ($('#yolo-modal-search').hasClass('in')) {
                $('#yolo-modal-search').removeClass('in');
                setTimeout(function() {
                    $('#yolo-modal-search').hide();
                    $('body').removeClass('overflow-hidden');
                }, 300);
            }
        },
        searchAjaxForm: function() {
            var $wrapper = $('header.yolo-main-header .search-box-wrapper');
            var $form_wrapper = $('header.yolo-main-header .search-box-wrapper form.search-type-ajax');
            $($window).click(function(event) {
                if ($(event.target).closest('header.yolo-main-header .search-box-wrapper').length == 0) {
                    $('.ajax-search-result', $wrapper).remove();
                    $('> input[type="text"]', $form_wrapper).val('');
                }
            });
            $form_wrapper.submit(function() {
                return false;
            });

            $('> input[type="text"]', $form_wrapper).on('keyup', function(event) {
                if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
                    return;
                }

                var keys = ["Control", "Alt", "Shift"];
                if (keys.indexOf(event.key) != -1) return;
                switch (event.which) {
                    case 27: // ESC
                        remove_search_result();
                        break;
                    case 38: // UP
                        CELINA.search.up($wrapper);
                        break;
                    case 40: // DOWN
                        CELINA.search.down($wrapper);

                        break;
                    case 13: //ENTER
                        s_enter();
                        break;
                    default:
                        clearTimeout(CELINA.header.timeOutSearch);
                        CELINA.header.timeOutSearch = setTimeout(s_search, 500);
                        break;
                }

                function remove_search_result() {
                    $('.ajax-search-result', $wrapper).remove();
                    $('> input[type="text"]', $form_wrapper).val('');
                }

                function s_enter() {
                    var $item = $('li.selected a', $wrapper);

                    if ($item.length > 0) {
                        window.location = $item.attr('href');
                    }
                }

                function s_search() {
                    var keyword = $('input[type="text"]', $form_wrapper).val();
                    if (keyword.length < 3) {
                        if ($('.ajax-search-result', $form_wrapper).length == 0) {
                            $($form_wrapper).append('<div class="ajax-search-result"></div>');
                        }
                        var hint_message = $wrapper.attr('data-hint-message');

                        $('.ajax-search-result', $wrapper).html('<ul><li class="no-result">' + hint_message + '</li></ul>');
                        return;
                    }
                    $('button > i', $form_wrapper).addClass('fa-spinner fa-spin');
                    $('button > i', $form_wrapper).removeClass('fa-search');
                    $.ajax({
                        type: 'POST',
                        data: 'action=result_search&keyword=' + keyword,
                        url: celina_framework_ajax_url[0],
                        success: function(data) {
                            $('button > i', $wrapper).removeClass('fa-spinner fa-spin');
                            $('button > i', $wrapper).addClass('fa-search');
                            var html = '';
                            var html_view_more = '';
                            if (data) {
                                var items = $.parseJSON(data);
                                if (items.length) {
                                    html += '<ul>';
                                    if (items[0]['id'] == -1) {
                                        html += '<li class="no-result">' + items[0]['title'] + '</li>';
                                    } else {
                                        $.each(items, function(index) {
                                            if (this['id'] == -2) {
                                                html_view_more = '<div class="search-view-more">' + this['title'] + '</div>';
                                            } else {
                                                if (index == 0) {
                                                    html += '<li class="selected">';
                                                } else {
                                                    html += '<li>';
                                                }
                                                if (this['title'] == null || this['title'] == '') {
                                                    html += '<a href="' + this['guid'] + '">' + this['date'] + '</a>';
                                                } else {
                                                    html += '<a href="' + this['guid'] + '">' + this['title'] + '</a>';
                                                }
                                                html += '</li>';
                                            }
                                        });
                                    }
                                    html += '</ul>';
                                } else {
                                    html = '';
                                }
                            }
                            if ($('.ajax-search-result', $form_wrapper).length == 0) {
                                $($form_wrapper).append('<div class="ajax-search-result"></div>');
                            }

                            $('.ajax-search-result', $wrapper).html(html + html_view_more);
                            $('.ajax-search-result ul', $wrapper).scrollTop(0);
                        },
                        error: function(data) {
                            $('button > i', $wrapper).removeClass('fa-spinner fa-spin');
                            $('button > i', $wrapper).addClass('fa-search');
                        }
                    });
                }
            });
        },
        searchCategory: function() {
            $('.search-with-category').each(function() {
                var $wrapperLeft = $('.form-search-left', this);
                var $wrapper = $(this);
                $(document).on('click', function(event) {
                    if ($(event.target).closest('.form-search-left', $wrapper).length === 0) {
                        $(' > ul', $wrapperLeft).slideUp();
                    }
                    if (($(event.target).closest('.form-search-right,.ajax-search-result', $wrapper).length === 0)) {
                        $('.ajax-search-result', $wrapper).remove();
                        $('input', $wrapper).val('');
                    }
                });

                var sHtml = '<li><span data-id="-1" data-value="' + $('> span', $wrapperLeft).text() + '">[' + $('> span', $wrapperLeft).text() + ']</span></li>';
                $('> ul', $wrapperLeft).prepend(sHtml);

                // Select Category
                $('> span', $wrapperLeft).on('click', function() {
                    $('> ul', $(this).parent()).slideToggle();
                });

                // Category Click
                $('li > span', $wrapperLeft).on('click', function() {
                    var $this = $(this);
                    var id = $this.attr('data-id');
                    var text = '';
                    if (typeof($this.attr('data-value')) != "undefined") {
                        text = $this.attr('data-value');
                    } else {
                        text = $this.text();
                    }

                    var $cate_current = $('> span', $wrapperLeft);
                    $cate_current.text(text);
                    $cate_current.attr('data-id', id);
                    $(' > ul', $wrapperLeft).slideUp();
                });

                // Search process
                //--------------------------------------------------------------------------------------
                var $inputSearch = $('input', $wrapper);
                $inputSearch.on('keyup', function(event) {
                    var s_timeOut_search = null;
                    if (event.altKey || event.ctrlKey || event.shiftKey || event.metaKey) {
                        return;
                    }

                    var keys = ["Control", "Alt", "Shift"];
                    if (keys.indexOf(event.key) != -1) return;
                    switch (event.which) {
                        case 37:
                        case 39:
                            break;
                        case 27: // ESC
                            $('.ajax-search-result', $wrapper).remove();
                            $(this).val('');
                            break;
                        case 38: // UP
                            CELINA.search.up($('.ajax-search-result', $wrapper));
                            break;
                        case 40: // DOWN
                            CELINA.search.down($('.ajax-search-result', $wrapper));
                            break;
                        case 13: //ENTER
                            var $item = $('.ajax-search-result li.selected a', $wrapper);
                            if ($item.length == 0) {
                                event.preventDefault();
                                return false;
                            }

                            window.location = $item.attr('href');

                            event.preventDefault();
                            return false;
                        default:
                            clearTimeout(s_timeOut_search);
                            s_timeOut_search = setTimeout(function() {
                                s_search($wrapper);
                            }, 500);
                            break;
                    }
                });
            });

            function s_search($wrapper) {
                var keyword = $('input[type="text"]', $wrapper).val();
                if (keyword.length < 3) {
                    if ($('.ajax-search-result', $wrapper).length == 0) {
                        $($wrapper).append('<div class="ajax-search-result"></div>');
                    }
                    var hint_message = $wrapper.attr('data-hint-message');

                    $('.ajax-search-result', $wrapper).html('<ul><li class="no-result">' + hint_message + '</li></ul>');
                    return;
                }
                $('button > i', $wrapper).addClass('fa-spinner fa-spin');
                $('button > i', $wrapper).removeClass('fa-search');
                $.ajax({
                    type: 'POST',
                    data: 'action=result_search_product&keyword=' + keyword + '&cate_id=' + $('.form-search-left > span', $wrapper).attr('data-id'),
                    url: celina_framework_ajax_url[0],
                    success: function(data) {
                        $('button > i', $wrapper).removeClass('fa-spinner fa-spin');
                        $('button > i', $wrapper).addClass('fa-search');
                        var html = '';
                        var sHtmlViewMore = '';
                        if (data) {
                            var items = $.parseJSON(data);
                            if (items.length) {
                                html += '<ul>';
                                if (items[0]['id'] == -1) {
                                    html += '<li class="no-result">' + items[0]['title'] + '</li>';
                                } else {
                                    $.each(items, function(index) {
                                        if (this['id'] == -2) {
                                            sHtmlViewMore = '<div class="search-view-more">' + this['title'] + '</div>';
                                        } else {
                                            if (index == 0) {
                                                html += '<li class="selected">';
                                            } else {
                                                html += '<li>';
                                            }
                                            html += '<a href="' + this['guid'] + '">';
                                            html += this['thumb'];
                                            html += this['title'] + '</a>';
                                            html += '<div class="price">' + this['price'] + '</div>';
                                            html += '</li>';
                                        }

                                    });
                                }
                                html += '</ul>';
                            } else {
                                html = '';
                            }
                        }
                        if ($('.ajax-search-result', $wrapper).length == 0) {
                            $($wrapper).append('<div class="ajax-search-result"></div>');
                        }

                        $('.ajax-search-result', $wrapper).html(html + sHtmlViewMore);

                        $('.ajax-search-result li', $wrapper).hover(function() {
                            $('.ajax-search-result li', $wrapper).removeClass('selected');
                            $(this).addClass('selected');
                        });

                        $('.ajax-search-result ul', $wrapper).scrollTop(0);

                    },
                    error: function(data) {
                        $('button > i', $wrapper).removeClass('fa-spinner fa-spin');
                        $('button > i', $wrapper).addClass('fa-search');
                    }
                });
            }
        }
    };
    CELINA.onReady = {
        init: function() {
            CELINA.common.init();
            CELINA.header.init();
            CELINA.page.init();
            CELINA.blog.init();
            CELINA.woocommerce.init();
        }
    };
    CELINA.onLoad = {
        init: function() {
            CELINA.header.windowLoad();
        }
    };
    CELINA.onResize = {
        init: function() {
            CELINA.header.windowResized();
        }
    };
    CELINA.onScroll = {
        init: function() {}
    };
    $(window).resize(CELINA.onResize.init);
    $(document).ready(CELINA.onReady.init);
    $(window).on('load', CELINA.onLoad.init);

    $(window).on('load', function() {
        $body.addClass('loaded');

    });

    // Start For Single Product Image
    var sync1 = $("#sync1", ".single-product-image-inner");
    var sync2 = $("#sync2", ".single-product-image-inner");
    var flag = false;
    var duration = 500;

    var $window = $(window),
        $body = $('body'),
        isRTL = $body.hasClass('rtl') ? true : false;
    if (sync1.length > 0) {
        sync1.owlCarousel({
            items: 1,
            margin: 0,
            rtl: isRTL,
            nav: true,
            autoHeight: true,
            navText: ["<i class='fal fa-caret-left'></i>", "<i class='fal fa-caret-right'></i>"],
            dots: false,
        })
            .on('changed.owl.carousel', function(e) {
                if (!flag) {
                    flag = true;
                    sync2.trigger('to.owl.carousel', [e.item.index, duration, true]);
                    flag = false;
                }

                // Add class synced to current slide
                var current = e.item.index;
                $("#sync2")
                    .find(".owl-item")
                    .removeClass("synced")
                    .eq(current)
                    .addClass("synced");
            });
    }
    if (sync2.length > 0) {
        sync2.owlCarousel({
            margin: 0,
            rtl: isRTL,
            responsive: {
                0: {
                    items: 3
                },
                480: {
                    items: 3
                },

                768: {
                    items: 4
                },
            },
            nav: true,
            navText: ["<i class='fal fa-caret-left'></i>", "<i class='fal fa-caret-right'></i>"],
            center: false,
            dots: false,
            onInitialized: function() {
                sync2.find(".owl-item").eq(0).addClass("synced");
            }
        })
            .on('click', '.owl-item', function() {
                sync1.trigger('to.owl.carousel', [$(this).index(), duration, true]);
            })
            .on('changed.owl.carousel', function(e) {
                if (!flag) {
                    flag = true;
                    sync1.trigger('to.owl.carousel', [e.item.index, duration, true]);
                    flag = false;
                }
            });
    }

    $(document).on('change', '.variations_form .variations select,.variations_form .variation_form_section select,div.select', function() {
        var variation_form = $(this).closest('.variations_form');
        var current_settings = {},
            reset_variations = variation_form.find('.reset_variations');
        variation_form.find('.variations select,.variation_form_section select').each(function() {
            // Encode entities
            var value = $(this).val();

            // Add to settings array
            current_settings[$(this).attr('name')] = jQuery(this).val();
        });

        variation_form.find('.variation_form_section div.select input[type="hidden"]').each(function() {
            // Encode entities
            var value = $(this).val();

            // Add to settings array
            current_settings[$(this).attr('name')] = jQuery(this).val();
        });

        var all_variations = variation_form.data('product_variations');

        var variation_id = 0;
        var match = true;

        for (var i = 0; i < all_variations.length; i++) {
            match = true;
            var variations_attributes = all_variations[i]['attributes'];
            for (var attr_name in variations_attributes) {
                var val1 = variations_attributes[attr_name];
                var val2 = current_settings[attr_name];
                if (val1 == undefined || val2 == undefined) {
                    match = false;
                    break;
                }
                if (val1.length == 0) {
                    continue;
                }

                if (val1 != val2) {
                    match = false;
                    break;
                }
            }
            if (match) {
                variation_id = all_variations[i]['variation_id'];
                break;
            }
        }

        if (variation_id > 0) {
            var index = parseInt($('img[data-variation_id*="|' + variation_id + '|"]', '#sync1').data('index'), 10);
            if (!isNaN(index)) {
                sync1.trigger('to.owl.carousel', [index, duration, true]);
            }
        }
    });
    // End For Single Product Image

    /* Click filter or search */
    $(document).on('click', '.yolo-filter-search .yolo-filter', function(e) {
        e.preventDefault();
        if ($('.yolo-search-field').hasClass('active')) {
            $('.yolo-search-field').slideUp(function() {
                $('.yolo-filter-search .yolo-search, .yolo-search-field').removeClass('active');
                if ($('.woocommerce-sidebar').hasClass('active')) {
                    $('.woocommerce-sidebar').removeClass('active');
                    $('.woocommerce-sidebar').slideUp();
                } else {
                    $('.woocommerce-sidebar').addClass('active');
                    $('.woocommerce-sidebar').slideDown();
                }
            });
        } else {
            $('.woocommerce-sidebar').slideToggle();
            $('.woocommerce-sidebar').css({ "display": "flex" });
        }
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');

        } else {
            $(this).addClass('active');
        }
    });
    $(document).on('click', '.yolo-filter-search .yolo-search', function(e) {
        e.preventDefault();
        $(this).toggleClass('active');

        if ($('.yolo-search-field').hasClass('active')) {
            $('.yolo-search-field').removeClass('active');
            $('.yolo-search-field').slideUp();
        } else {
            $('.yolo-search-field').addClass('active');
            $('.woocommerce-sidebar.top').removeClass('active');
            $('.yolo-search-field').slideDown();
        }
    });
    /* End */

    /* filter */
    var shop_ajax = $('.site-content-archive-product').attr('data-ajax');
    if (typeof(shop_ajax) != "undefined" && shop_ajax == 'enable') {
        $(document).on('click', '.yolo-filter-categories li a, aside ul li a, .tagcloud a,.yolo-product-category > a,.yolo-shop-results-bar a', function(e) {
            e.preventDefault();
            var auto_close = $('.yolo-filter-search .yolo-filter').data('auto-close');
            $('.archive-product-wrap').removeClass('yolo-loaded-product');
            $('.archive-product-wrap').addClass('yolo-loading-product');
            $('.yolo-filter-search .yolo-search').removeClass('active');

            if (auto_close == '1') {
                $('.woocommerce-sidebar.top').slideUp();
            }
            $('.yolo-search-field').slideUp();
            $('.archive-product-wrap .woocommerce-no-products').css('opacity', '0');
            $('.woocommerce-pagination .yolo-shop-loadmore').addClass('yolo-hide-loadmore');
            $('.tagcloud > a').removeClass('current-tag');
            if ($(this).closest('.yolo-filter-categories').length > 0) {
                $('.yolo-filter-categories li').removeClass('current-cat');
                $(this).parent().addClass('current-cat');
                var x = document.getElementsByClassName("page-title");
                if (x.length > 0) {
                    x[0].innerHTML = $(this).text();
                }
            } else {
                $('.yolo-filter-categories li').removeClass('current-cat');
            }
            window.history.pushState({}, '', $(this).attr('href'));
            e.preventDefault();

            $('.product-listing, .woocommerce-no-products').before('<div class="yolo-spinner"><i class="fal fa-spinner fa-spin"></i></div>');
            var url = $(this).attr('href');
            url = url.replace(/\/?(\?|#|$)/, "/$1");
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    shop_load: 'full'
                },
                success: function(data) {
                    $('.yolo-spinner').remove();
                    $('.archive-product-wrap').removeClass('yolo-loading-product');
                    $('.archive-product-wrap').html(data);
                    $('.archive-product-wrap').addClass('yolo-loaded-product');
                    $('.woocommerce-pagination .yolo-shop-loadmore').addClass('yolo-show-loadmore');
                    $('.tagcloud > a').each(function() {
                        if ($(this).attr('href') == window.location.href) {
                            $(this).addClass('current-tag');
                        }
                    });
                    CELINA.woocommerce.init();
                    CELINA.common.tooltip();
                    yoloInitGrid();
                    setTimeout(function() {
                        $('.archive-product-wrap').removeClass('yolo-loaded-product');
                        $('.woocommerce-pagination .yolo-shop-loadmore').removeClass('yolo-show-loadmore');
                    }, 500);
                }
            })
        });
        /* end filter */

        /* Search: click = press enter if have button/input type=submit tag inside form */
        $(document).on('click', '.yolo-search-field button[type="submit"]', function(e) {
            $('.woocommerce-pagination .yolo-shop-loadmore').css('opacity', '0');
            e.preventDefault();
            var keyword_search = $('.yolo-search-field .search-field').val();
            keyword_search = keyword_search.trim();
            if (keyword_search.length) {
                e.preventDefault();
                if ($('.product-listing').length) {
                    $('.product-listing').html('<div class="yolo-spinner"><i class="fal fa-spinner fa-spin"></i></div>');
                } else if ($('.woocommerce-no-products').length) {
                    $('.woocommerce-no-products').html('<div class="yolo-spinner"><i class="fal fa-spinner fa-spin"></i></div>');
                }
                $.ajax({
                    url: celina_framework_constant.get_search_url + encodeURIComponent(keyword_search),
                    type: 'GET',
                    data: {
                        shop_load: "full",
                        post_type: "product"
                    },
                    success: function(data) {
                        $('.yolo-filter-categories > li').removeClass('current-cat');
                        $('.yolo-spinner').html();
                        $('.archive-product-wrap').html(data);
                        if ($('.yolo-filter-search .yolo-search').hasClass('active')) {
                            $('.yolo-search-field .search-field').val(keyword_search);
                        }
                        CELINA.woocommerce.init();
                        CELINA.common.tooltip();
                        yoloInitGrid();
                    }
                });
                $('.search-message').html('');
            } else {
                $('.search-message').html(celina_framework_constant.enter_keyword);
            }
        });
        /* End search */

        /* Product Load more */
        $(document).on('click', '.yolo-shop-loadmore', function(e) {
            e.preventDefault();
            var link = $(this).data('link');
            var current_page = $(this).data('page');
            var totalpage = $(this).data('totalpage');

            var loading = $(this).attr('data-loading-text');
            var load_more = $(this).attr('data-load-text');

            if (totalpage < current_page) {
                $('.woocommerce-pagination').html('<div class="yolo-show-all jhana-btn">' + celina_framework_constant.yolo_all_products + '</div>').addClass('yolo-all-product');
            } else {
                $(this).attr('href', link.replace('%#%', current_page));
                $(this).data('page', current_page + 1);
                $('.woocommerce-pagination .yolo-shop-loadmore').text('').append('<i class="fal fa-spinner fa-spin"></i> Loading...');
                $.ajax({
                    url: $(this).attr('href'),
                    type: 'POST',
                    data: {
                        shop_load: 'full',
                        pagination: 'load_more'
                    },
                    success: function(data) {
                        $('.woocommerce-pagination .yolo-shop-loadmore').text('Load more');
                        $('.woocommerce-pagination .yolo-shop-loadmore').blur();
                        var newItems = (data);
                        newItems = "<div>" + data + "</div>";
                        newItems = $(newItems).children(".yolo-filter-result").children(".product-item-wrap");
                        $('.product-listing').append(newItems);
                        CELINA.woocommerce.init();
                        CELINA.common.tooltip();
                        yoloInitGrid();
                    }
                });
            }
        });
        /* End load more*/
    }

    /* Add class for current tag */
    if ($('.tagcloud').length == 1) {
        $('.tagcloud > a').each(function() {
            if ($(this).attr('href') == window.location.href) {
                $(this).addClass('current-tag');
            }
        });
    }

});
